module.exports = __webpack_public_path__ + "img/93ee15b.jpg";